<template>
  <main class="app-main">
    <!--begin::App Content Header-->
    <div class="app-content-header">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div class="row">
          <div class="col-sm-6"><h3 class="mb-0">{{ rowTitle }}</h3></div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-end">
              <li class="breadcrumb-item"><router-link to="/">الرئيسية</router-link></li>
              <li class="breadcrumb-item"><router-link to="/adLicenseReq">طلبات اصدار ترخيص اعلاني</router-link></li>
              <li class="breadcrumb-item active" aria-current="page">{{ rowTitle }}</li>
            </ol>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content Header-->
    <!--begin::App Content-->
    <div class="app-content">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div class="row justify-content-center">
          <div class="col-12 col-sm-10">
            <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
            <mainLoader v-if="mainLoading" />
            <AdLicenseReqForm v-if="!mainLoading && checkAccess('ad_license_requests_update')" 
              :cardTitle="rowTitle" 
              :dataRow="row" 
              :statusObject="statusChoices"
              :adTypeObject="adTypeChoices"
            />
            <AdLicenseReqView v-if="!mainLoading && !checkAccess('ad_license_requests_update')" 
              :cardTitle="rowTitle" 
              :dataRow="row" 
              :statusObject="statusChoices"
              :adTypeObject="adTypeChoices"
            />
          </div>
        </div>

        <div class="row justify-content-center">
          <div class="col-12 col-sm-10">
            <div>
              <AdminNotesPanel
                v-if="!mainLoading"
                modelName="AdLicenseRequests"
                :recordId="id"
              />
            </div>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content-->
  </main>
</template>

<script>
import { checkAccess } from '@/helpers/tools';
import AdLicenseReqForm from './form.vue';
import AdLicenseReqView from './view.vue';
import AdminNotesPanel from '../admin_notes/adminNotesPanel.vue';

export default {
  name: 'AdLicenseReqUpdate',
  components: {
    AdLicenseReqForm, AdLicenseReqView, AdminNotesPanel
  },
  data(){
    return {
      id: this.$route.params.id,
      mainLoading: true,
      hasError: false,
      message: '',
      errorNumber: 0,
      rowTitle: 'تعديل طلب اصدار ترخيص اعلاني رقم ',
      row: null,
      statusChoices: {},
      adTypeChoices: {},
    }
  },
  methods: {
    checkAccess,
    getRowData(){
      this.$http.get(`/api/admin/adLicenseReq/retrieve/${this.id}`).then(({data}) => {
        this.rowTitle = this.rowTitle + data.row.id;
        this.row = data.row;
        this.statusChoices = data.statusChoices;
        this.adTypeChoices = data.adTypeChoices;
        this.mainLoading = false;
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    },
  },
  created(){
    this.getRowData();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}
</script>
